import dayjs from 'dayjs';

/**
 * @example output
 * "2:45 PM"
 */
export const formatTo12HourTime = (timestamp: string) =>
  dayjs(timestamp).format('h:mm A');
